// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Terms$OrcaPaymentPage from "../Components/Terms.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Surcharge$OrcaPaymentPage from "../Components/Surcharge.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as GlobalVars$OrcaPaymentPage from "../GlobalVars.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "../Utilities/PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as DynamicFields$OrcaPaymentPage from "../Components/DynamicFields.bs.js";
import * as PaymentBodyV2$OrcaPaymentPage from "../Utilities/PaymentBodyV2.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "../Utilities/RecoilAtomsV2.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";
import * as PaymentHelpersV2$OrcaPaymentPage from "../Utilities/PaymentHelpersV2.bs.js";
import * as ClickToPayDetails$OrcaPaymentPage from "../Components/ClickToPayDetails.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../Components/PaymentInputField.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";
import * as SaveDetailsCheckbox$OrcaPaymentPage from "../Components/SaveDetailsCheckbox.bs.js";
import * as NicknamePaymentInput$OrcaPaymentPage from "../Components/NicknamePaymentInput.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./PaymentMethodsRecord.bs.js";
import * as PaymentManagementBody$OrcaPaymentPage from "../Utilities/PaymentManagementBody.bs.js";
import * as ClickToPayCardEncryption$OrcaPaymentPage from "../Utilities/ClickToPayCardEncryption.bs.js";

function CardPayment(props) {
  var __isVault = props.isVault;
  var __isBancontact = props.isBancontact;
  var cvcProps = props.cvcProps;
  var expiryProps = props.expiryProps;
  var cardProps = props.cardProps;
  var isBancontact = __isBancontact !== undefined ? __isBancontact : false;
  var isVault = __isVault !== undefined ? Caml_option.valFromOption(__isVault) : undefined;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var match$1 = match.config.appearance;
  var innerLayout = match$1.innerLayout;
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var email = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userEmailAddress);
  var fullName = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userFullName);
  var phoneNumber = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userPhoneNumber);
  var match$2 = React.useState(function () {
        return false;
      });
  var isSaveDetailsWithClickToPay = match$2[0];
  var clickToPayConfig = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var match$3 = React.useState(function () {
        return "";
      });
  var setClickToPayCardBrand = match$3[1];
  var clickToPayCardBrand = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var isClickToPayRememberMe = match$4[0];
  var ctpCards = Core__Option.getOr(clickToPayConfig.clickToPayCards, []);
  var nickname = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userCardNickName);
  var match$5 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var clientSecret = match$5.clientSecret;
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var paymentTypeFromUrl = CardThemeType$OrcaPaymentPage.getPaymentMode(componentName);
  var giftCardInfo = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.giftCardInfoAtom);
  var isPMMFlow;
  isPMMFlow = paymentTypeFromUrl === "PaymentMethodsManagement" ? true : false;
  var paymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  var setCvcError = cvcProps.setCvcError;
  var cvcError = cvcProps.cvcError;
  var cvcNumber = cvcProps.cvcNumber;
  var isCVCValid = cvcProps.isCVCValid;
  var setExpiryError = expiryProps.setExpiryError;
  var expiryError = expiryProps.expiryError;
  var cardExpiry = expiryProps.cardExpiry;
  var isExpiryValid = expiryProps.isExpiryValid;
  var cardBrand = cardProps.cardBrand;
  var setCardError = cardProps.setCardError;
  var cardError = cardProps.cardError;
  var cardNumber = cardProps.cardNumber;
  var isCardSupported = cardProps.isCardSupported;
  var isCardValid = cardProps.isCardValid;
  var match$6 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var savedPaymentMethodsCheckboxCheckedByDefault = match$6.savedPaymentMethodsCheckboxCheckedByDefault;
  var intent = PaymentHelpers$OrcaPaymentPage.usePaymentIntent(loggerState, "Card");
  var saveCard = PaymentHelpersV2$OrcaPaymentPage.useSaveCard(loggerState, "Card");
  var match$7 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var setShowPaymentMethodsScreen = match$7[1];
  var showPaymentMethodsScreen = match$7[0];
  var setComplete = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.fieldsComplete);
  var blockedBinsList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.blockedBins);
  var match$8 = React.useState(function () {
        return savedPaymentMethodsCheckboxCheckedByDefault;
      });
  var isSaveCardsChecked = match$8[0];
  var clickToPayProvider = clickToPayConfig.clickToPayProvider;
  React.useEffect((function () {
          if (cardBrand === "" || !clickToPayConfig.availableCardBrands.includes(cardBrand.toLowerCase())) {
            setClickToPayCardBrand(function (param) {
                  return "";
                });
          } else if (cardBrand !== clickToPayCardBrand) {
            setClickToPayCardBrand(function (param) {
                  return cardBrand;
                });
          }
          
        }), [
        cardBrand,
        clickToPayConfig.availableCardBrands
      ]);
  var combinedCardNetworks = React.useMemo((function () {
          var cardPaymentMethod = Core__Option.getOr(paymentMethodListValue.payment_methods.find(function (ele) {
                    return ele.payment_method === "card";
                  }), PaymentMethodsRecord$OrcaPaymentPage.defaultMethods);
          var cardNetworks = cardPaymentMethod.payment_method_types.map(function (ele) {
                return ele.card_networks;
              });
          var cardNetworkNames = cardNetworks.map(function (ele) {
                return ele.map(function (val) {
                            return CardUtils$OrcaPaymentPage.getCardStringFromType(val.card_network).toLowerCase();
                          });
              });
          return Utils$OrcaPaymentPage.getUniqueArray(Core__Array.reduce(cardNetworkNames, [], (function (acc, ele) {
                            return acc.concat(ele);
                          })));
        }), [paymentMethodListValue]);
  var isCardBrandValid = combinedCardNetworks.includes(cardBrand.toLowerCase());
  var match$9 = React.useState(function () {
        return {};
      });
  var requiredFieldsBody = match$9[0];
  var areRequiredFieldsValid = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var complete = Utils$OrcaPaymentPage.isAllValid(isCardValid, isCardSupported, isCVCValid, isExpiryValid, true, "payment");
  var empty = cardNumber === "" || cardExpiry === "" || cvcNumber === "";
  React.useEffect((function () {
          setComplete(function (param) {
                return complete;
              });
          setShowPaymentMethodsScreen(function (param) {
                return true;
              });
        }), [complete]);
  UtilityHooks$OrcaPaymentPage.useHandlePostMessages(complete && areRequiredFieldsValid, empty, "card", undefined);
  var isGuestCustomer = UtilityHooks$OrcaPaymentPage.useIsGuestCustomer();
  var isCvcValidValue = CardUtils$OrcaPaymentPage.getBoolOptionVal(isCVCValid);
  var match$10 = CardUtils$OrcaPaymentPage.useCardDetails(cvcNumber, isCvcValidValue, isCVCValid);
  var isCustomerAcceptanceRequired = UtilityHooks$OrcaPaymentPage.useIsCustomerAcceptanceRequired(match$6.displaySavedPaymentMethodsCheckbox, isSaveCardsChecked, isGuestCustomer);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          var match = CardUtils$OrcaPaymentPage.getExpiryDates(cardExpiry);
          var year = match[1];
          var month = match[0];
          var onSessionBody = [[
              "customer_acceptance",
              PaymentBody$OrcaPaymentPage.customerAcceptanceBody
            ]];
          var cardNetwork = [[
              "card_network",
              cardBrand !== "" ? cardBrand : null
            ]];
          var defaultCardBody;
          defaultCardBody = GlobalVars$OrcaPaymentPage.sdkVersion === "V1" ? PaymentBody$OrcaPaymentPage.cardPaymentBody(cardNumber, month, year, Caml_option.some(undefined), cvcNumber, cardNetwork, nickname.value) : PaymentManagementBody$OrcaPaymentPage.saveCardBody(cardNumber, month, year, Caml_option.some(undefined), cvcNumber, cardNetwork, nickname.value);
          var banContactBody = PaymentBody$OrcaPaymentPage.bancontactBody();
          var cardBody = isCustomerAcceptanceRequired ? defaultCardBody.concat(onSessionBody) : defaultCardBody;
          var isRecognizedClickToPayPayment = ctpCards.length > 0 && clickToPayCardBrand !== "";
          if (!confirm.doSubmit) {
            return ;
          }
          var isCardDetailsValid = Core__Option.getOr(isCVCValid, false) && Core__Option.getOr(isCardValid, false) && Core__Option.getOr(isCardSupported, false) && Core__Option.getOr(isExpiryValid, false);
          var isNicknameValid = nickname.value === "" || Core__Option.getOr(nickname.isValid, false);
          var isCardBlocked = CardUtils$OrcaPaymentPage.checkIfCardBinIsBlocked(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber), blockedBinsList);
          var validFormat = (isBancontact || isCardDetailsValid) && isNicknameValid && areRequiredFieldsValid && !isCardBlocked;
          if (validFormat && (showPaymentMethodsScreen || isBancontact)) {
            if (isRecognizedClickToPayPayment || isSaveDetailsWithClickToPay) {
              ClickToPayHelpers$OrcaPaymentPage.handleOpenClickToPayWindow();
              switch (clickToPayProvider) {
                case "VISA" :
                    var expiry = cardExpiry.split("/").map(function (prim) {
                          return prim.trim();
                        });
                    var month$1 = Core__Option.getOr(expiry.at(0), "");
                    var year$1 = "20" + Core__Option.getOr(expiry.at(1), "");
                    var payload = [
                      Utils$OrcaPaymentPage.convertKeyValueToJsonStringPair("primaryAccountNumber", cardNumber.replaceAll(" ", "")),
                      Utils$OrcaPaymentPage.convertKeyValueToJsonStringPair("panExpirationMonth", month$1),
                      Utils$OrcaPaymentPage.convertKeyValueToJsonStringPair("panExpirationYear", year$1),
                      Utils$OrcaPaymentPage.convertKeyValueToJsonStringPair("cardSecurityCode", cvcNumber.trim()),
                      Utils$OrcaPaymentPage.convertKeyValueToJsonStringPair("cardHolderName", fullName.value.trim())
                    ];
                    var dict = {};
                    payload.forEach(function (param) {
                          dict[param[0]] = param[1];
                        });
                    ((async function () {
                            var encryptedCard = await ClickToPayCardEncryption$OrcaPaymentPage.getEncryptedCard(dict);
                            try {
                              var res = await ClickToPayHelpers$OrcaPaymentPage.handleProceedToPay(undefined, undefined, true, ctpCards.length === 0, email.value, phoneNumber.value, Core__Option.getOr(phoneNumber.countryCode, "").replace("+", ""), isClickToPayRememberMe, loggerState, encryptedCard, clickToPayProvider, undefined, clickToPayConfig.clickToPayToken, Core__Option.getOr(clientSecret, ""), fullName.value);
                              var dict$1 = Utils$OrcaPaymentPage.getDictFromJson(res.payload);
                              var clickToPayBody = PaymentBody$OrcaPaymentPage.visaClickToPayBody(Utils$OrcaPaymentPage.getString(dict$1, "checkoutResponse", ""), clickToPayConfig.email);
                              return intent(false, clickToPayBody, confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                            }
                            catch (raw_err){
                              var err = Caml_js_exceptions.internalToOCamlException(raw_err);
                              return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                                                  message: "Error during checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                                                  scheme: clickToPayProvider
                                                }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                            }
                          })());
                    return ;
                case "MASTERCARD" :
                    try {
                      ((async function () {
                              var res = await ClickToPayHelpers$OrcaPaymentPage.encryptCardForClickToPay(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber), month, CardUtils$OrcaPaymentPage.formatExpiryToTwoDigit(year), cvcNumber, loggerState);
                              if (res.TAG !== "Ok") {
                                return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                                                    message: "Error during checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(res._0)),
                                                    scheme: clickToPayProvider
                                                  }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                              }
                              var resp = await ClickToPayHelpers$OrcaPaymentPage.handleProceedToPay(undefined, res._0, true, ctpCards.length === 0, email.value, phoneNumber.value, Core__Option.getOr(phoneNumber.countryCode, "").replace("+", ""), isClickToPayRememberMe, loggerState, undefined, clickToPayProvider, undefined, clickToPayConfig.clickToPayToken, undefined, undefined);
                              var dict = Utils$OrcaPaymentPage.getDictFromJson(resp.payload);
                              var headers = Utils$OrcaPaymentPage.getDictFromDict(dict, "headers");
                              var merchantTransactionId = Utils$OrcaPaymentPage.getString(headers, "merchant-transaction-id", "");
                              var xSrcFlowId = Utils$OrcaPaymentPage.getString(headers, "x-src-cx-flow-id", "");
                              var correlationId = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "checkoutResponseData"), "srcCorrelationId", "");
                              var clickToPayBody = PaymentBody$OrcaPaymentPage.mastercardClickToPayBody(merchantTransactionId, correlationId, xSrcFlowId);
                              return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(clickToPayBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
                            })());
                      return ;
                    }
                    catch (raw_err){
                      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
                      return loggerState.setLogError(Core__Option.getOr(JSON.stringify({
                                          message: "Error during checkout - " + JSON.stringify(Utils$OrcaPaymentPage.formatException(err)),
                                          scheme: clickToPayProvider
                                        }), ""), "CLICK_TO_PAY_FLOW", undefined, undefined, undefined, undefined, undefined);
                    }
                case "NONE" :
                    return ;
                
              }
            } else {
              if (isPMMFlow) {
                return saveCard(true, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(cardBody, requiredFieldsBody), confirm.confirmParams);
              }
              var hasGiftCards = giftCardInfo.appliedGiftCards.length > 0;
              var modifiedCardBody;
              if (hasGiftCards) {
                var splitPaymentBody = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(PaymentBodyV2$OrcaPaymentPage.splitPaymentBody(giftCardInfo.appliedGiftCards)));
                modifiedCardBody = Utils$OrcaPaymentPage.mergeAndFlattenToTuples(cardBody, splitPaymentBody);
              } else {
                modifiedCardBody = cardBody;
              }
              return intent(false, Utils$OrcaPaymentPage.mergeAndFlattenToTuples(isBancontact ? banContactBody : modifiedCardBody, requiredFieldsBody), confirm.confirmParams, undefined, undefined, undefined, isManualRetryEnabled, undefined);
            }
          } else {
            if (cardNumber === "") {
              setCardError(function (param) {
                    return localeString.cardNumberEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
            } else if (isCardBlocked) {
              setCardError(function (param) {
                    return localeString.blockedCardText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.blockedCardText);
            } else if (!Core__Option.getOr(isCardSupported, true)) {
              if (cardBrand === "") {
                setCardError(function (param) {
                      return localeString.enterValidCardNumberErrorText;
                    });
                Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
              } else {
                setCardError(function (param) {
                      return localeString.cardBrandConfiguredErrorText(cardBrand);
                    });
                var message = localeString.cardBrandConfiguredErrorText(cardBrand);
                Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", message);
              }
            }
            if (cardExpiry === "") {
              setExpiryError(function (param) {
                    return localeString.cardExpiryDateEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
            }
            if (!isBancontact && cvcNumber === "") {
              setCvcError(function (param) {
                    return localeString.cvcNumberEmptyText;
                  });
              Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
            }
            if (!validFormat) {
              return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
            } else {
              return ;
            }
          }
        }), [
        areRequiredFieldsValid,
        requiredFieldsBody,
        empty,
        complete,
        isCustomerAcceptanceRequired,
        nickname,
        isCardBrandValid,
        isManualRetryEnabled,
        cardProps,
        clickToPayConfig,
        clickToPayCardBrand,
        isClickToPayRememberMe,
        blockedBinsList,
        giftCardInfo
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  var paymentMethod = isBancontact ? "bank_redirect" : "card";
  var paymentMethodType = isBancontact ? "bancontact_card" : "debit";
  var conditionsForShowingSaveCardCheckbox = Core__Option.isNone(paymentMethodListValue.mandate_payment) && !isGuestCustomer && paymentMethodListValue.payment_type !== "SETUP_MANDATE" && options.displaySavedPaymentMethodsCheckbox && !isBancontact;
  var compressedLayoutStyleForCvcError = innerLayout === "Compressed" && cvcError.length > 0 ? "!border-l-0" : "";
  var vaultClass = isVault !== undefined ? "mb-[4px] mr-[4px] ml-[4px] mt-[4px]" : "";
  return React.createElement("div", {
              className: "animate-slowShow"
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showPaymentMethodsScreen || isBancontact,
                  children: React.createElement("div", {
                        className: "flex flex-col " + vaultClass,
                        style: {
                          gridGap: themeObj.spacingGridColumn
                        }
                      }, React.createElement("div", {
                            className: "flex flex-col w-full",
                            style: {
                              gridGap: themeObj.spacingGridColumn
                            }
                          }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                                condition: innerLayout === "Compressed",
                                children: React.createElement("div", {
                                      style: {
                                        fontSize: themeObj.fontSizeLg,
                                        marginBottom: "5px",
                                        opacity: "0.6"
                                      }
                                    }, localeString.cardHeader)
                              }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                condition: !isBancontact,
                                children: null
                              }, React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                    isValid: Caml_option.some(isCardValid),
                                    setIsValid: cardProps.setIsCardValid,
                                    value: cardNumber,
                                    onChange: cardProps.changeCardNumber,
                                    onBlur: cardProps.handleCardBlur,
                                    rightIcon: Caml_option.some(cardProps.icon),
                                    errorString: cardError,
                                    fieldName: localeString.cardNumberLabel,
                                    name: TestUtils$OrcaPaymentPage.cardNoInputTestId,
                                    type_: "tel",
                                    maxLength: cardProps.maxCardLength,
                                    placeholder: "1234 1234 1234 1234",
                                    className: innerLayout === "Compressed" && cardError.length > 0 ? "border-b-0" : "",
                                    inputRef: cardProps.cardRef,
                                    autocomplete: "cc-number"
                                  }), React.createElement("div", {
                                    className: "flex flex-row w-full place-content-between",
                                    style: {
                                      gridColumnGap: innerLayout === "Spaced" ? themeObj.spacingGridRow : ""
                                    }
                                  }, React.createElement("div", {
                                        className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                                      }, React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                            isValid: Caml_option.some(isExpiryValid),
                                            setIsValid: expiryProps.setIsExpiryValid,
                                            value: cardExpiry,
                                            onChange: expiryProps.changeCardExpiry,
                                            onBlur: expiryProps.handleExpiryBlur,
                                            errorString: expiryError,
                                            fieldName: localeString.validThruText,
                                            name: TestUtils$OrcaPaymentPage.expiryInputTestId,
                                            type_: "tel",
                                            maxLength: 7,
                                            placeholder: localeString.expiryPlaceholder,
                                            inputRef: expiryProps.expiryRef,
                                            autocomplete: "cc-exp"
                                          })), React.createElement("div", {
                                        className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                                      }, React.createElement(PaymentInputField$OrcaPaymentPage.make, {
                                            isValid: Caml_option.some(isCVCValid),
                                            setIsValid: cvcProps.setIsCVCValid,
                                            value: cvcNumber,
                                            onChange: cvcProps.changeCVCNumber,
                                            onBlur: cvcProps.handleCVCBlur,
                                            rightIcon: Caml_option.some(CardUtils$OrcaPaymentPage.setRightIconForCvc(match$10[0], match$10[2], themeObj.colorIconCardCvcError, match$10[1])),
                                            errorString: cvcError,
                                            fieldName: localeString.cvcTextLabel,
                                            name: TestUtils$OrcaPaymentPage.cardCVVInputTestId,
                                            type_: "tel",
                                            maxLength: 4,
                                            placeholder: "123",
                                            className: "tracking-widest w-full " + compressedLayoutStyleForCvcError,
                                            inputRef: cvcProps.cvcRef,
                                            autocomplete: "cc-csc"
                                          }))), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                    condition: innerLayout === "Compressed" && (cardError.length > 0 || cvcError.length > 0 || expiryError.length > 0),
                                    children: React.createElement("div", {
                                          className: "Error pt-1",
                                          style: {
                                            color: themeObj.colorDangerText,
                                            fontSize: themeObj.fontSizeSm,
                                            textAlign: "left",
                                            alignSelf: "start"
                                          }
                                        }, "Invalid input")
                                  })), React.createElement(DynamicFields$OrcaPaymentPage.make, {
                                paymentMethod: paymentMethod,
                                paymentMethodType: paymentMethodType,
                                setRequiredFieldsBody: match$9[1],
                                cardProps: Caml_option.some(cardProps),
                                expiryProps: Caml_option.some(expiryProps),
                                cvcProps: Caml_option.some(cvcProps),
                                isBancontact: isBancontact,
                                isSaveDetailsWithClickToPay: isSaveDetailsWithClickToPay
                              }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                condition: conditionsForShowingSaveCardCheckbox,
                                children: React.createElement("div", {
                                      className: "flex items-center justify-start"
                                    }, React.createElement(SaveDetailsCheckbox$OrcaPaymentPage.make, {
                                          isChecked: isSaveCardsChecked,
                                          setIsChecked: match$8[1]
                                        }))
                              }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                                condition: !options.hideCardNicknameField && isCustomerAcceptanceRequired || paymentType === "PaymentMethodsManagement",
                                children: React.createElement(NicknamePaymentInput$OrcaPaymentPage.make, {})
                              })))
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showPaymentMethodsScreen || isBancontact,
                  children: React.createElement(Surcharge$OrcaPaymentPage.make, {
                        paymentMethod: paymentMethod,
                        paymentMethodType: paymentMethodType,
                        cardBrand: CardUtils$OrcaPaymentPage.getCardType(cardBrand)
                      })
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: !isBancontact,
                  children: React.createElement(Terms$OrcaPaymentPage.make, {
                        styles: {
                          marginTop: themeObj.spacingGridColumn
                        },
                        paymentMethod: paymentMethod,
                        paymentMethodType: paymentMethodType
                      })
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: clickToPayCardBrand !== "",
                  children: React.createElement("div", {
                        className: "space-y-3 mt-2"
                      }, React.createElement(ClickToPayHelpers$OrcaPaymentPage.SrcMark.make, {
                            "card-brands": clickToPayCardBrand,
                            height: "32"
                          }), React.createElement(ClickToPayDetails$OrcaPaymentPage.make, {
                            isSaveDetailsWithClickToPay: isSaveDetailsWithClickToPay,
                            setIsSaveDetailsWithClickToPay: match$2[1],
                            clickToPayCardBrand: clickToPayCardBrand,
                            isClickToPayRememberMe: isClickToPayRememberMe,
                            setIsClickToPayRememberMe: match$4[1]
                          }))
                }));
}

var make = CardPayment;

export {
  make ,
}
/* react Not a pure module */
